import { api } from "../api/http.js";
import type { Bundle, CosmeticView, LuckyView, PassView, PurchaseResult, ShopView, StoreCard, StoreView, VipView } from "./types.js";

export const storeApi = {
  catalogue: () => api<StoreView>("GET", "/api/store"),
  buy: (key: string, opts: { premiumPlus?: boolean; unitRowId?: string; qty?: number } = {}) => api<PurchaseResult>("POST", "/api/store/buy", { key, ...opts }),
  refreshDaily: () => api<{ cards: StoreCard[]; freeLeft: number; price: number }>("POST", "/api/store/daily/refresh"),
};

export const passesApi = {
  list: () => api<{ passes: PassView[] }>("GET", "/api/passes").then((d) => d.passes),
  claim: (id: string, key: number) => api<{ pass: PassView; granted: Bundle }>("POST", `/api/passes/${id}/claim`, { key }),
  buyTier: (id = "pass.battle") => api<{ pass: PassView }>("POST", `/api/passes/${id}/tier`).then((d) => d.pass),
};

export const vipApi = {
  view: () => api<VipView>("GET", "/api/vip"),
  claimChest: () => api<{ granted: Bundle }>("POST", "/api/vip/chest"),
};

export const luckyApi = {
  view: () => api<LuckyView>("GET", "/api/lucky"),
  spin: () => api<{ segmentId: string; reward: Bundle; jackpot: number; free: boolean }>("POST", "/api/lucky/wheel"),
  claimMilestone: (track: "spend" | "vault", index: number) => api<{ granted: Bundle }>("POST", `/api/lucky/milestones/${track}/${index}`),
  shoot: (count = 1) => api<{ revealed: { index: number; reward: Bundle; grand: boolean }[]; round: number; shots: number; granted: Bundle }>("POST", "/api/lucky/vault/shoot", { count }),
  draw: () => api<{ pct: number; guaranteed: boolean; index: number; shopUntil: number }>("POST", "/api/lucky/discount/draw"),
  buyDiscounted: (itemId: string, coupon: number) => api<{ price: number; granted: Bundle }>("POST", "/api/lucky/discount/buy", { itemId, coupon }),
  capsule: () => api<{ capsuleId: string; reward: Bundle; key: string | null; free: boolean }>("POST", "/api/lucky/capsule"),
  openChest: (colour: string) => api<{ granted: Bundle }>("POST", "/api/lucky/capsule/open", { colour }),
};

export const shopsApi = {
  list: () => api<{ shops: ShopView[] }>("GET", "/api/shops").then((d) => d.shops),
  buy: (id: string, itemId: string) => api<{ granted: Bundle; balance: number; shop: ShopView }>("POST", `/api/shops/${id}/buy`, { itemId }),
};

export const cosmeticsApi = {
  list: () => api<{ cosmetics: CosmeticView[] }>("GET", "/api/cosmetics").then((d) => d.cosmetics),
  equip: (id: string, rowId?: string) => api<{ ok: true }>("POST", `/api/cosmetics/${id}/equip`, rowId ? { rowId } : {}),
  unequip: (id: string) => api<{ ok: true }>("POST", `/api/cosmetics/${id}/unequip`),
};
